import Backbone from 'backbone';
import ko from 'knockout';
import _ from 'underscore';
import { HeadlinesViewModel, DescriptionsViewModel } from '@bingads-webui-campaign-legacy/crud-ad/viewmodel/adsEditor/responsiveListField';
import headlinesTemplate from '@bingads-webui-campaign-legacy/crud-ad/template/adsEditor/headlines.pug';
import desciptionsTemplate from '@bingads-webui-campaign-legacy/crud-ad/template/adsEditor/descriptions.pug';
import uuid from '@bingads-webui-component-legacy/uuid/index';
import config from '@bingads-webui-component-legacy/config/index';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

class RSAListView extends Backbone.View {
  validateViewModel() {
    const isValid = this.viewModel.validate();

    if (!isValid) {
      _.each(this.fields, (field) => {
        if (!this.viewModel[field].isValid()) {
          if (this.activityLogger) {
            this.activityLogger.signal(`ad field invalid: ${field}`, 'responsive search ad editor');
          }
        }
      });
    }

    return isValid;
  }

  validate() {
    this.viewModel.needValication(true);
    return _.reduce([
      this.validateViewModel(),
      _.isEmpty(this.viewModel.errorMessage()),
    ], (prev, next) => {
      return prev && next;
    }, true);
  }

  toObject() {
    const params = this.viewModel.toObject();
    const fieldsValue = _.chain(this.fields)
      .filter((field) => !_.isEmpty(params[field].trim()))
      .map((field) => ({
        'Asset': {
          '@odata.type': '#Model.TextAsset',
          'AssetType': 'Text',
          'Name': null,
          'Text': params[field].trim(),
        },
        'PinnedField': this.viewModel[`${field}Position`](),
        'IsAIGeneratedAsset': this.viewModel[`${field}IsAIGeneratedAsset`](),
      })).value();

    return fieldsValue;
  }

  // [TODO] Will update the parameters base on the interface
  toBulkEditObject() {
    let fieldsValue = _.chain(this.fields)
      .filter((field) => !_.isEmpty(this.viewModel[field]().trim()))
      .map((field) => ({
        'Text': this.viewModel[field]().trim(),
        'PinnedField': this.viewModel[`${field}Position`](),
      })).value();

    fieldsValue = _.map(fieldsValue, (value) => {
      return JSON.stringify(value);
    });

    return fieldsValue;
  }
}

export class HeadlinesView extends RSAListView {
  initialize({
    model = null,
    defaultCount = 5,
    maxCount = 15,
    miniRequire = 3,
    isForVNext = false,
    activityLogger,
    showLightbulb = false,
    isMMA = false,
  } = {}) {
    this.isForVNext = isForVNext;
    this.fields = _.map(_.range(maxCount), (i) => `Headline${i}`);
    config.set('headlineFields', this.fields);
    this.template = headlinesTemplate;
    this.activityLogger = activityLogger;
    this.viewModel = new HeadlinesViewModel({ model, maxCount, defaultCount, miniRequire, isForVNext, activityLogger });
    this.showLightbulb = showLightbulb;
    this.isMMA = isMMA;
    this.maxCount = maxCount;
    return this;
  }

  get events() {
    return {
      'click .ad-rsa-add-headline': 'addHeadline',
    };
  }

  render() {
    this.$el.html(this.template({
      i18n,
      uuid,
      fields: this.fields,
      showLightbulb: this.showLightbulb,
      isMMA: this.isMMA,
    }));
    ko.applyBindings(this.viewModel, this.el);
    return this;
  }

  addHeadline() {
    if (this.viewModel.showHeadlineCount() < this.maxCount) {
      this.viewModel.showHeadlineCount(this.viewModel.showHeadlineCount() + 1);
    }
  }
}

export class DescriptionsView extends RSAListView {
  initialize({
    model = null,
    defaultCount = 2,
    maxCount = 4,
    miniRequire = 2,
    isForVNext = false,
    activityLogger,
    showLightbulb = false,
    isMMA = false,
  } = {}) {
    this.isForVNext = isForVNext;
    this.fields = _.map(_.range(maxCount), (i) => `Description${i}`);
    config.set('descriptionFields', this.fields);
    this.template = desciptionsTemplate;
    this.activityLogger = activityLogger;
    this.viewModel = new DescriptionsViewModel({ model, maxCount, defaultCount, miniRequire, isForVNext, activityLogger });
    this.showLightbulb = showLightbulb;
    this.isMMA = isMMA;
    this.maxCount = maxCount;
    return this;
  }

  get events() {
    return {
      'click .ad-rsa-add-description': 'addDescription',
    };
  }

  render() {
    this.$el.html(this.template({
      i18n,
      uuid,
      fields: this.fields,
      showLightbulb: this.showLightbulb,
      isMMA: this.isMMA,
    }));
    ko.applyBindings(this.viewModel, this.el);
    return this;
  }

  addDescription() {
    if (this.viewModel.showDescriptionCount() < this.maxCount) {
      this.viewModel.showDescriptionCount(this.viewModel.showDescriptionCount() + 1);
    }
  }
}
